import { Link } from 'react-router-dom'
import { useAuth } from 'src/contexts/auth.context'
import { routes } from 'src/navigation/routes'

export const AuthorDashboard = () => {
  const { user } = useAuth()

  return (
    <>
      <h2 className="sectionHb-title">Dashboard</h2>
      <div className="sectionHb-block dashboardHb">
        <div className="sectionHb-block__wrap">
          <h2 className="sectionHb-title">
            Welcome,{' '}
            <span>
              {user.first_name} {user.last_name}
            </span>
          </h2>
          <div className="dashboardHb-img">
            <img src="/account/img/dashboard/img-2.svg" alt="" />
          </div>
          {/* <p>Welcome to your <b>Practithink</b> account! <br/>Create tests, sell printouts. Educate your children and help others.</p> */}
          <div className="practithinkHb">
            <span className="practithinkHb-title">
              Your Practithink starts here
            </span>
            <div className="row">
              <div className="practithinkHb-col col-lg-3 col-md-4 col-sm-6">
                <Link
                  to={routes.practices.options}
                  className="practithinkHb-wrap"
                >
                  <div className="practithinkHb-ico">
                    <img src="/account/img/dashboard/ico-6.svg" alt="" />
                  </div>
                  <span className="practithinkHb-subtitle">Create task</span>
                </Link>
              </div>
              <div className="practithinkHb-col col-lg-3 col-md-4 col-sm-6">
                <Link to={routes.profile.index} className="practithinkHb-wrap">
                  <div className="practithinkHb-ico">
                    <img src="/account/img/dashboard/ico-7.svg" alt="" />
                  </div>
                  <span className="practithinkHb-subtitle">Manage profile</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
